import Swal from "sweetalert2";

window.Swal = Swal;

window.SwalLoading = Swal.mixin({
  position: "center",
  showConfirmButton: false,
  allowOutsideClick: false,
  onBeforeOpen: () => {
    Swal.showLoading();
  }
});

window.SwalError = Swal.mixin({
  icon: "error",
  position: "center",
  showConfirmButton: false,
  allowOutsideClick: false
});

window.SwalSuccess = Swal.mixin({
  icon: "success",
  position: "center",
  showConfirmButton: false,
  allowOutsideClick: false
});

window.SwalInfo = Swal.mixin({
  icon: "info",
  position: "center",
  showConfirmButton: true,
  allowOutsideClick: true
});

window.SwalWarning = Swal.mixin({
  icon: "warning",
  showConfirmButton: true,
  showCancelButton: true,
  allowOutsideClick: true
});

window.SwalToast = Swal.mixin({
  toast: true,
  position: "top-end",
  timer: 5000,
  timerProgressBar: true,
  showConfirmButton: false,
  onOpen: toast => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  }
});

window.SwalQueue = Swal.mixin({
  showCancelButton: true,
  confirmButtonText: "Next"
});
